import React from 'react';

const initialState = ['bot.view.bot.get','test_conversation.view.clients.get','es.view.es.faq.list','nlu_training_data.view.examples.list'];
const { Provider: AppProvider, Consumer: AppConsumer } = React.createContext(initialState);

export {AppProvider,AppConsumer};
